import React, { Component } from "react";

function Counter() {
  return (
    <>
      <div className="counter">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div
              className="col-xl-4 col-md-6 text-center wow fadeInUp"
              data-wow-duration="0.3s"
              data-wow-delay="0.3s"
            >
              <div className="page-counter">
                <div className="counter-item">
                  <h2 className="title">
                    <span className="count-num">1528</span>+
                  </h2>
                  <p className="text">Donations</p>
                </div>
              </div>
            </div>
            <div
              className="col-xl-4 col-md-6 text-center wow fadeInUp"
              data-wow-duration="0.4s"
              data-wow-delay="0.4s"
            >
              <div className="page-counter">
                <div className="counter-item">
                  <h2 className="title">
                    <span className="count-num">3</span>k+
                  </h2>
                  <p className="text">Volunteers</p>
                </div>
              </div>
            </div>
            <div
              className="col-xl-4 col-md-6 text-center wow fadeInUp"
              data-wow-duration="0.5s"
              data-wow-delay="0.5s"
            >
              <div className="page-counter">
                <div className="counter-item">
                  <h2 className="title">
                    <span className="count-num">240</span>+
                  </h2>
                  <p className="text">Missions</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Counter;
